import React from 'react';
import styled from 'styled-components';

import { IconButton } from 'styled_components/Common/IconButton';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const CloseIcon = `${CDN_URL}common/X-close-primary.svg`;

const PortraitModalStyle = styled.div`
	width: 496px;
	height: 608px;
	min-height: 608px;
	overflow: none;
	background: ${props => props.theme.modalBackground};
	color: ${props => props.theme.defaultFontColor};
	box-shadow: 0 0 55px 0 ${props => props.theme.boxShadow};
	display: flex;
	flex-direction: column;
	position: relative;

	&.no-padding {
		.main-content {
			padding: 0px !important;
		}
		.header-content {
			padding: 0px !important;
		}
	}

	&.reverse {
		flex-direction: column-reverse;
	}
	.modal-footer {
		position: absolute;
		bottom: 0;
		left: 0;
	}
	.section-header-title {
		margin-bottom: 8px;
	}
	&.showOverflow {
		.main-content {
			overflow: visible;
		}
	}
	.main-content {
		padding: 15px 30px 50px 40px;
		height: 100%;
		overflow: hidden;
	}
	.header-content {
		padding: 10px 30px 0px 40px;
		display: flex;
		align-items: center;
		flex-direction: center;
	}

	&.medium {
		width: 368px;
		height: 456px;
		min-height: 456px;
		box-shadow: 0 0 45px 0 ${props => props.theme.boxShadow};
		.section-header {
			padding-left: 32px;
			padding-right: 16px;
		}
		.portrait-modal-header {
			height: 152px;
		}
		.portrait-modal-body {
			height: 304px;
		}
		.header-content {
			padding: 10px 30px 0px 32px;
		}
		.main-content {
			padding: 15px 30px 50px 32px;
		}
	}
	&.small {
		width: 240px;
		height: 304px;
		min-height: 304px;
		box-shadow: 0 0 35px 0 ${props => props.theme.boxShadow};
		.portrait-modal-body {
			display: none;
		}
		.portrait-modal-header {
			height: 304px;
		}
		.section-header {
			padding-left: 32px;
			padding-right: 16px;
		}
	}
	.section-header {
		display: flex;
		height: 40px;
		position: relative;
		align-items: center;
		padding-left: 40px;
		padding-right: 24px;
		padding-top: 24px;
		background: ${props => props.theme.white};

		.section-header-title {
			width: 100%;
		}
		.section-header-button {
			position: absolute;
			top: 10px;
			right: 10px;
		}
	}

	.portrait-modal-header {
		background: ${props => props.theme.white};
		height: 152px;
		.header-content {
			height: 112px;
		}
	}
	.portrait-modal-body {
		background: ${props => props.theme.modalBackground};
		height: 456px;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 736px;
		height: 864px;
		min-height: 864px;
		box-shadow: 0 0 65px 0 ${props => props.theme.boxShadow};
		.main-content {
			padding: 30px 48px 50px 48px;
		}
		.header-content {
			padding: 20px 48px 0px 48px;
		}
		.section-header-title {
			margin-bottom: 16px;
		}
		&.medium {
			width: 544px;
			height: 648px;
			min-height: 648px;
			box-shadow: 0 0 50px 0 ${props => props.theme.boxShadow};

			.section-header {
				padding-left: 48px;
				padding-right: 25px;
			}
			.portrait-modal-header {
				height: 216px;
			}
			.portrait-modal-body {
				height: 376px;
			}
			.header-content {
				padding: 20px 48px 0px 48px;
			}
			.main-content {
				padding: 30px 48px 50px 48px;
			}
		}
		&.small {
			width: 352px;
			height: 432px;
			min-height: 432px;
			box-shadow: 0 0 40px 0 ${props => props.theme.boxShadow};
			.portrait-modal-body {
				display: none;
			}
			.portrait-modal-header {
				height: 432px;
			}
			.section-header {
				padding-left: 23px;
				padding-right: 25px;
			}
		}
		.section-header {
			height: 66px;
			padding-left: 48px;
			padding-right: 24px;
			.section-header-button {
				position: absolute;
				top: 15px;
				right: 15px;
			}
		}

		.portrait-modal-header {
			height: 216px;
			.header-content {
				height: 160px;
			}
		}
		.portrait-modal-body {
			height: 648px;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 1232px;
		height: 1280px;
		min-height: 1280px;
		box-shadow: 0 0 80px 0 ${props => props.theme.boxShadow};

		.main-content {
			padding: 50px 64px 50px 64px;
		}
		.header-content {
			padding: 30px 64px 0px 64px;
		}

		&.medium {
			width: 912px;
			height: 1008px;
			min-height: 1008px;
			.section-header {
				padding-left: 64px;
				padding-right: 32px;
			}
			.portrait-modal-header {
				height: 336px;
			}
			.portrait-modal-body {
				height: 672px;
			}
			.header-content {
				padding: 30px 64px 0px 64px;
			}
			.main-content {
				padding: 50px 64px 50px 64px;
			}
		}
		&.small {
			width: 592px;
			height: 672px;
			min-height: 672px;
			.portrait-modal-body {
				display: none;
			}
			.portrait-modal-header {
				height: 672px;
			}
			.section-header {
				padding-left: 48px;
				padding-right: 24px;
			}
		}
		.section-header {
			height: 74px;
			padding-left: 64px;
			padding-right: 32px;
			.section-header-button {
				position: absolute;
				top: 20px;
				right: 20px;
			}
		}

		.portrait-modal-header {
			height: 336px;
			.header-content {
				height: 272px;
			}
		}
		.portrait-modal-body {
			height: 1008px;
		}
	}
`;

export const PortraitModal = ({
	closeModal,
	size,
	children,
	header,
	title,
	subTitle,
	customClassName,
	breakpoint,
}) => {
	return (
		<PortraitModalStyle
			className={`portrait-modal-container-${customClassName} ${size} ${customClassName}`}
		>
			{header && (
				<div className='portrait-modal-header'>
					<div className='section-header'>
						<div className='section-header-title heading60'>{title}</div>
						{closeModal && (
							<div className='section-header-button'>
								<IconButton
									enabled={true}
									id='icon-button'
									module={module}
									onClick={closeModal}
									style={{ cursor: 'pointer' }}
									breakpoint={breakpoint}
								>
									<img data-cy='close-button' src={CloseIcon} alt='' />
								</IconButton>
							</div>
						)}
					</div>
					<div className='header-content'>{header}</div>
				</div>
			)}
			{!header && closeModal && (
				<div className='section-header'>
					<div className='section-header-title heading60'>{title}</div>
					{closeModal && (
						<div className='section-header-button'>
							<IconButton
								enabled={true}
								id='icon-button'
								module={module}
								onClick={closeModal}
								style={{ cursor: 'pointer' }}
							>
								<img data-cy='close-button' src={CloseIcon} alt='' />
							</IconButton>
						</div>
					)}
				</div>
			)}
			<div className='portrait-modal-body'>
				{subTitle && (
					<div className='section-header'>
						<div className='section-header-title heading60'>{subTitle}</div>
						<div className='section-header-button'></div>
					</div>
				)}
				<div className='main-content'>{children}</div>
			</div>
		</PortraitModalStyle>
	);
};
